<script lang="ts">
import { Inertia } from "@inertiajs/inertia";
import Calendar from "@/Components/Calendar.vue";
import AppLayout from "@/Layouts/App.vue";
import { defineComponent, PropType } from "vue";
import MainPage from "@/Components/MainPage.vue";
import { Event } from "@/Types/event";

export default defineComponent({
    components: {
        MainPage,
        Calendar,
    },
    layout: AppLayout,
    props: {
        events: {
            type: Array as PropType<Event[]>,
            default: () => [],
        },
        year: {
            type: Number,
            default: () => new Date().getFullYear(),
        },
        isReload: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        goToYear(y: number): void {
            Inertia.get("/events", { year: y, _reload: true }, { preserveScroll: true });
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('navigation.nav_events')" :gap="true" :disable-animation="isReload">
        <Calendar :year="year" :events="events" @change-year="goToYear" />
    </MainPage>
</template>
